import MyService from '../../service';

const DirectDiscountApi = {
  getAll: async () =>
    MyService.getRequestData('/direct-discount')
      .then((result) => result.data)
      .catch((err) => console.log(err)),
  getById: async (directDiscountId) => {
    console.log('GET direct discount by directDiscountId ', directDiscountId);
    return MyService.getRequestData(`/direct-discount/${directDiscountId}`)
      .then((result) => result.data)
      .catch((err) => console.log(err));
  },
  create: async (directDiscount) => {
    console.log('add new directDiscount ', directDiscount);
    return MyService.postRequestData(
      '/direct-discount/',
      directDiscount
    ).catch((err) => console.log(err));
  },
  deleteDirectDiscount: async (directDiscountId) => {
    console.log(
      'DELETE direct discount by direct_discount_id',
      directDiscountId
    );
    return MyService.deleteRequestData(`/direct-discount/${directDiscountId}`);
  },
  update: async (directDiscountId, params) => {
    console.log(
      'UPDATE direct discount by direct_discount_id',
      directDiscountId,
      params
    );
    return MyService.putRequestData(
      `/direct-discount/${directDiscountId}`,
      params
    );
  },
};

export default DirectDiscountApi;

export const DISCOUNT_TYPE = {
  DIRECT_DISCOUNT: 0,
  DIRECT_DISCOUNT_RECURRING: 1,
};
